import PageSectionData from '@v4/utils/data/PageSectionData'
import Eye from '@v4/components/common/FAIcons/Regular/Eye'
import LowVision from '@v4/components/common/FAIcons/Regular/LowVision'

export const ICONS_COMPONENTS = {
	[PageSectionData.VISIBILITY.HIDE]: Eye,
	[PageSectionData.VISIBILITY.SHOW]: Eye,
	[PageSectionData.VISIBILITY.HIDE_AUDIENCE_BASED]: LowVision,
	[PageSectionData.VISIBILITY.SHOW_AUDIENCE_BASED]: LowVision,
}
